<template>
  <div class="order_details">
    <!-- EXPORT ACCESSORY ORDER SECTION -->
    <div class="accessory-order-container" v-if="exportAccessoryOrderMode == true">
      <b-button class="print-hiden-content" @click="quitExportMode">Back</b-button>
      <b-button class="ml-2 print-hiden-content" @click="printAccessoryOrder" variant="success">Print</b-button>
      <div class="text-center">
        <b-row class="text-left">
          <b-col cols="6" style="font-size: 26px"><b>Purchase Order</b></b-col>
          <b-col cols="6"><img src="../../assets/StonemartLogo.png"></b-col>
        </b-row>
        <b-row class="text-left px-4">
          <b-col cols="6"><b>To: </b>{{ viewedAccessoryOrder.to }}</b-col>
          <b-col cols="6"><b>Date: </b>{{ viewedAccessoryOrder.date }}</b-col>
        </b-row>
        <b-row class="text-left px-4">
          <b-col cols="6"><b>Store Location: </b>{{ viewedAccessoryOrder.storeLocation }}</b-col>
          <b-col cols="6"><b>Sales:</b>{{ viewedAccessoryOrder.salesPerson }}</b-col>
        </b-row>
        <b-row class="text-left mt-4">
          <b-col>
            <b>Door</b>
          </b-col>
        </b-row>
        <b-row>
          <b-table
            bordered
            :fields="exportAccessoryOrderDoorFields"
            :items="viewedAccessoryOrder.doors"
          >
          </b-table>
        </b-row>
        <b-row class="text-left">
          <b-col>
            <b>Accessory</b>
          </b-col>
        </b-row>
        <b-row>
          <b-table
            bordered
            :fields="exportAccessoryOrderAccessoryFields"
            :items="viewedAccessoryOrder.accessories"
          >
          </b-table>
        </b-row>
        <b-row class="text-left">
          <p><b>Note:</b></p>
          <ul>
            <li>Please use invoice number on your delivery docket as a reference number for each purchased item, to ensure a prompt and accurate payment.</li>
            <li>Your payment might be delayed if there is no invoice number.</li>
          </ul>
        </b-row>
        <b-row class="text-left">
          <b-col cols="6">
            <input type="checkbox" name="pickup" value="pickup">
            <label>Pick Up</label><br>
          </b-col>
          <b-col cols="6">
            <input type="checkbox" name="postto" value="pickup">
            <label>Post To: </label><br>
          </b-col>
        </b-row>
        <br><br><br><br>
        <b-row>
          <p>Sales Person Signature:</p>
        </b-row>
        <b-row class="bottom-content text-center">
          <p>Tel: 03-93590898 Fax: 03-93599196 Email: info@johnstonemart.com website: www.johnstonemart.com.au</p>
          <p>310 Mahoneys Road, Thomastown VIC 3074</p>
        </b-row>
      </div>
    </div>
    <div v-if="exportAccessoryOrderMode == false">
      <!-- <div v-if="user.name == 'Rick'">1.1.6</div> -->
      <b-button @click="back()" class="fixed-bottom"> Back </b-button>
      <b-form @submit.prevent="editOrderTask">
        <b-row>
          <b-col cols="4">
            <h4 class="text-right m-0 p-0">Basic</h4>
            <b-row>
              <b-col cols="12" v-for="item in viewOrderFormBasicInputs" :key="item.key">
                <label :for="`viewed-order-input-${item.key}`">{{item.label}}<span style="color: red" v-if="item.mandatory">*</span></label>
                <b-form-input size="sm" v-if="item.form_type == 'text-input'" :id="`viewed-order-input-${item.key}`" :type="item.type" v-model="viewedOrder[item.key]" :required="item.mandatory"></b-form-input>
                <span v-if="item.form_type == 'text-input-list'">
                  <b-form-input :id="`new-order-input-${item.key}`" :type="item.type" v-model="viewedOrder[item.key]" :required="item.mandatory" :list="item.listName"></b-form-input>
                  <datalist :id="item.listName">
                    <option v-for="(option, index) in dataLists[item.listName]" :key="item.label + index">{{ option }}</option>
                  </datalist>
                </span>
                <b-form-select size="sm" v-if="item.form_type == 'select'"
                  :id="`viewed-order-input-${item.key}`"
                  v-model="viewedOrder[item.key]" 
                  :required="item.mandatory"
                  :options="selectOptions[item.options]"
                ></b-form-select>
                <b-form-textarea
                  size="sm" 
                  v-if="item.form_type == 'textarea'"
                  id="viewed-order-description"
                  v-model="viewedOrder.description"
                  rows="3"
                  max-rows="6"
                  :required="true"
                ></b-form-textarea>
              </b-col>
            </b-row>
            <div class="mt-4 modal-footer">
              <span id="update-button-1">
                <b-button class="ml-1" variant="success" type="submit" :disabled="user.name != viewedOrder.salesName && user.role != 'admin'">
                  <span v-if="!isUpdating">Update</span>
                  <span v-if="isUpdating">
                    <b-spinner small type="grow"></b-spinner>
                    Update...
                  </span>
                </b-button>
              </span>
              <b-tooltip v-if="user.name != viewedOrder.salesName  && user.role != 'admin'"
                target="update-button-1" triggers="hover">
                Only owner and admin can modify the order
              </b-tooltip>
            </div>
            <br><br>
          </b-col>
          <b-col cols="8">
            <b-tabs>
              <b-tab title="Accounting" active title-link-class="text-success">
                <b-row>
                  <b-col cols="6" v-for="item in viewOrderFormAccounting" :key="item.key">
                    <label :for="`viewed-order-input-${item.key}`">{{item.label}}<span style="color: red" v-if="item.mandatory">*</span></label>
                    <b-form-input :disabled="item.key == 'invoiceNumber' && user.role != 'admin'" v-if="item.form_type == 'text-input'" :id="`viewed-order-input-${item.key}`" :type="item.type" v-model="viewedOrder[item.key]" min="0.00"></b-form-input>
                    <b-form-select v-if="item.form_type == 'select'"
                      :id="`viewed-order-input-${item.key}`"
                      v-model="viewedOrder[item.key]" 
                      :options="selectOptions[item.options]"
                    ></b-form-select>
                    <b-form-datepicker v-if="item.form_type == 'datepicker'"
                      :id="`new-order-input-${item.key}`"
                      v-model.trim="viewedOrder[item.key]" 
                      :required="item.mandatory"
                      today-button
                      reset-button
                      close-button
                      :disabled="(item.key=='orderDate' || item.key=='orderingConfirmDate') && user.role == 'sales'"
                    ></b-form-datepicker>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Ordering" title-link-class="text-success">
                <b-tabs class="mt-2">
                  <b-tab
                  title="General"
                  title-link-class="text-success">
                    <b-row>
                      <b-col cols="6" v-for="item in viewOrderFormOrdering" :key="item.key">
                        <label :for="`viewed-order-input-${item.key}`">{{item.label}}<span v-if="item.mandatory" style="color: red">*</span></label>
                        <b-form-input v-if="item.form_type == 'text-input'" :id="`viewed-order-input-${item.key}`" :type="item.type" v-model="viewedOrder[item.key]" :disabled="item.key == 'invoiceNumber' && user.name != 'Rick'"></b-form-input>
                        <b-form-select v-if="item.form_type == 'select'"
                          :id="`viewed-order-input-${item.key}`"
                          v-model="viewedOrder[item.key]"
                          :options="selectOptions[item.options]"
                        ></b-form-select>
                        <b-form-datepicker v-if="item.form_type == 'datepicker'"
                          :id="`new-order-input-${item.key}`"
                          v-model.trim="viewedOrder[item.key]" 
                          :required="item.mandatory"
                          today-button
                          reset-button
                          close-button
                          :disabled="(item.key=='orderDate' || item.key=='orderingConfirmDate') && user.role == 'sales'"
                        ></b-form-datepicker>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab
                  title="Stone Order"
                  title-link-class="text-success">
                    <template #title>
                      <b-row class="text-center">
                        <b-col>
                          Stone Order <b-icon v-if="viewedOrder.stoneOrderSent != null && viewedOrder.stoneOrderSent == true" class="text-center" icon="check-square" scale="1" variant="success"></b-icon>
                        </b-col>
                      </b-row>
                    </template>
                    <p v-if="this.isUploadingFile" style="color: red">
                    Files are being uploaded. Please do not close the page.
                    </p>
                    <b-spinner v-if="isUploadingFile" label="Spinning"></b-spinner>
                    <div v-if="this.viewedOrder.files.length == 0">
                      This event does not have any file yet.
                    </div>
                    <div v-if="this.viewedOrder.files.length > 0" class="file-list mt-2">
                      <div v-for="(file, index) in viewedOrder.files" :key="index">
                        <div v-if="file.fileType && file.fileType == 'stone_order'">
                          <b-row class="mt-1 ml-1" align-h="between" v-if="file.fileType && file.fileType == 'stone_order'">
                            <div>
                              <b-icon
                                v-if="user.name == viewedOrder.salesName || user.role == 'admin'"
                                class="mt-1 pointer"
                                icon="trash-fill"
                                scale="1"
                                variant="danger"
                                @click="deleteFile(index)"
                              ></b-icon>
                              <span style="color: green; cursor: pointer;text-decoration: underline;" @click="downloadFile(index)">{{ file.fileName }}</span>
                              <span style="color: grey;" v-if="file.uploader != null">uploaded by {{ file.uploader }} on {{ file.uploadDate }} [{{  file.fileType }}]</span>
                            </div>
                          </b-row>
                          <hr class="m-0 p-0" />
                        </div>
                      </div>
                    </div>
                    <div class="fileUploadPanel">
                      <b-form-file
                        class="mt-3"
                        v-model="selectedFile"
                        :state="Boolean(selectedFile)"
                        placeholder="Choose files or drop those here..."
                        drop-placeholder="Drop file here..."
                      ></b-form-file>
                      <div class="mt-3">
                        Selected files: {{ this.selectedFiles.length }}
                      </div>
                      <div>
                        <b-row
                          class="mt-1 ml-1"
                          v-for="(file, index) in selectedFiles"
                          :key="index"
                        >
                          {{ file.name }}
                          <b-icon
                            class="mt-1 ml-1 pointer"
                            icon="x-circle"
                            scale="1"
                            variant="danger"
                            @click="removeFile(index)"
                          ></b-icon>
                        </b-row>
                      </div>
                      <!-- <b-progress class="mt-2" v-if="isUploading" :value="progress" :max="max" show-progress animated></b-progress> -->
                      <b-button
                        v-if="user.name == viewedOrder.salesName || user.role == 'admin'"
                        :disabled="
                          this.selectedFiles.length == 0 || this.isUploadingFile
                            ? true
                            : false
                        "
                        class="mt-4"
                        block
                        variant="success"
                        @click="uploadFiles('stone_order')"
                      >
                        Upload</b-button>
                    </div>
                    <b-button v-if="this.user.role == 'admin'" class="mt-2" size="sm" variant="success" @click="startSendOrder('Stone Order')">Send Stone Order</b-button>
                  </b-tab>
                  <b-tab
                  title="purchase_order"
                  title-link-class="text-success">
                    <template #title>
                      <b-row class="text-center">
                        <b-col>
                          Purchase Order <b-icon v-if="viewedOrder.purchaseOrderSent != null && viewedOrder.purchaseOrderSent == true" class="text-center" icon="check-square" scale="1" variant="success"></b-icon>
                        </b-col>
                      </b-row>
                    </template>
                    <div class="m-1">
                      <b-button variant="success" @click="createAccessoryOrderButtonClicked">Create New Accessory Order</b-button>
                      <div class="accessory-container" v-for="(order, index) in viewedOrder.accessoryOrders" :key="'accessoryOrder' + index" @click="viewAccessoryOrder(order)">
                        <div class="flex-container">
                          <div><b>To:</b> {{ order.to }}</div>
                          <div><b>Date:</b> {{ order.date }}</div>
                          <div><b>Store:</b> {{ order.storeLocation }}</div>
                          <div><b>Sales:</b> {{ order.salesPerson }}</div>
                        </div>
                        <div class="flex-container" v-for="(door, index) in order.doors" :key="'accessoryOrder-door-' + index">
                          <div><b>Item Code:</b> {{ door.itemCode }}</div>
                          <div><b>Status:</b> {{ door.status }}</div>
                          <div><b>Size:</b> {{ door.size }}</div>
                          <div><b>FrameColor:</b> {{ door.frameColor }}</div>
                          <div><b>PerspexColor:</b> {{ door.perspexColor }}</div>
                          <div><b>Qty:</b> {{ door.qty }}</div>
                          <div><b>Price:</b> {{ door.price }}</div>
                        </div>
                        <div class="flex-container" v-for="(accessory, index) in order.accessories" :key="'accessoryOrder-accessory-' + index">
                          <div><b>Item Code:</b> {{ accessory.itemCode }}</div>
                          <div><b>Status:</b> {{ accessory.status }}</div>
                          <div><b>Description:</b> {{ accessory.description }}</div>
                          <div><b>Qty:</b> {{ accessory.qty }}</div>
                          <div><b>Price:</b> {{ accessory.price }}</div>
                        </div>
                      </div>
                    </div>
                    <p v-if="this.isUploadingFile" style="color: red">
                      Files are being uploaded. Please do not close the page.
                    </p>
                    <b-spinner v-if="isUploadingFile" label="Spinning"></b-spinner>
                    <div v-if="this.viewedOrder.files.length == 0">
                      This event does not have any file yet.
                    </div>
                    <div v-if="this.viewedOrder.files.length > 0" class="file-list mt-2">
                      <div v-for="(file, index) in viewedOrder.files" :key="index">
                        <div v-if="file.fileType == 'purchase_order'">
                          <b-row class="mt-1 ml-1" align-h="between">
                            <div>
                              <b-icon
                                v-if="user.name == viewedOrder.salesName || user.role == 'admin'"
                                class="mt-1 pointer"
                                icon="trash-fill"
                                scale="1"
                                variant="danger"
                                @click="deleteFile(index)"
                              ></b-icon>
                              <span style="color: green; cursor: pointer;text-decoration: underline;" @click="downloadFile(index)">{{ file.fileName }}</span>
                              <span style="color: grey;" v-if="file.uploader != null">uploaded by {{ file.uploader }} on {{ file.uploadDate }} [{{  file.fileType }}]</span>
                            </div>
                          </b-row>
                          <hr class="m-0 p-0" />
                        </div>
                      </div>
                    </div>
                    <div class="fileUploadPanel">
                      <b-form-file
                        class="mt-3"
                        v-model="selectedFile"
                        :state="Boolean(selectedFile)"
                        placeholder="Choose files or drop those here..."
                        drop-placeholder="Drop file here..."
                      ></b-form-file>
                      <div class="mt-3">
                        Selected files: {{ this.selectedFiles.length }}
                      </div>
                      <div>
                        <b-row
                          class="mt-1 ml-1"
                          v-for="(file, index) in selectedFiles"
                          :key="index"
                        >
                          {{ file.name }}
                          <b-icon
                            class="mt-1 ml-1 pointer"
                            icon="x-circle"
                            scale="1"
                            variant="danger"
                            @click="removeFile(index)"
                          ></b-icon>
                        </b-row>
                      </div>
                      <b-button
                        v-if="user.name == viewedOrder.salesName || user.role == 'admin'"
                        :disabled="
                          this.selectedFiles.length == 0 || this.isUploadingFile
                            ? true
                            : false
                        "
                        class="mt-4"
                        block
                        variant="success"
                        @click="uploadFiles('purchase_order')"
                      >
                        Upload</b-button
                      >
                    </div>
                    <b-button v-if="this.user.role == 'admin'" class="mt-2" size="sm" variant="success" @click="startSendOrder('Purchase Order')">Send Purchase Order</b-button>
                  </b-tab>
                  <b-tab
                    title="Inscription Booking"
                    title-link-class="text-success">
                    <template #title>
                      <b-row class="text-center">
                        <b-col>
                          Inscription Booking<b-icon v-if="viewedOrder.inscriptionBookingSent != null && viewedOrder.inscriptionBookingSent == true" class="text-center" icon="check-square" scale="1" variant="success"></b-icon>
                        </b-col>
                      </b-row>
                    </template>
                    <p v-if="this.isUploadingFile" style="color: red">
                      Files are being uploaded. Please do not close the page.
                    </p>
                    <b-spinner v-if="isUploadingFile" label="Spinning"></b-spinner>
                    <div v-if="this.viewedOrder.files.length == 0">
                      This event does not have any file yet.
                    </div>
                    <div v-if="this.viewedOrder.files.length > 0" class="file-list mt-2">
                      <div v-for="(file, index) in viewedOrder.files" :key="index">
                        <div v-if="file.fileType == 'inscription_booking'">
                          <b-row class="mt-1 ml-1" align-h="between">
                            <div>
                              <b-icon
                                v-if="user.name == viewedOrder.salesName || user.role == 'admin'"
                                class="mt-1 pointer"
                                icon="trash-fill"
                                scale="1"
                                variant="danger"
                                @click="deleteFile(index)"
                              ></b-icon>
                              <span style="color: green; cursor: pointer;text-decoration: underline;" @click="downloadFile(index)">{{ file.fileName }}</span>
                              <span style="color: grey;" v-if="file.uploader != null">uploaded by {{ file.uploader }} on {{ file.uploadDate }} [{{  file.fileType }}]</span>
                            </div>
                          </b-row>
                          <hr class="m-0 p-0" />
                        </div>
                      </div>
                    </div>
                    <div class="fileUploadPanel">
                      <b-form-file
                        class="mt-3"
                        v-model="selectedFile"
                        :state="Boolean(selectedFile)"
                        placeholder="Choose files or drop those here..."
                        drop-placeholder="Drop file here..."
                      ></b-form-file>
                      <div class="mt-3">
                        Selected files: {{ this.selectedFiles.length }}
                      </div>
                      <div>
                        <b-row
                          class="mt-1 ml-1"
                          v-for="(file, index) in selectedFiles"
                          :key="index"
                        >
                          {{ file.name }}
                          <b-icon
                            class="mt-1 ml-1 pointer"
                            icon="x-circle"
                            scale="1"
                            variant="danger"
                            @click="removeFile(index)"
                          ></b-icon>
                        </b-row>
                      </div>
                      <b-button
                        v-if="user.name == viewedOrder.salesName || user.role == 'admin'"
                        :disabled="
                          this.selectedFiles.length == 0 || this.isUploadingFile
                            ? true
                            : false
                        "
                        class="mt-4"
                        block
                        variant="success"
                        @click="uploadFiles('inscription_booking')"
                      >
                        Upload</b-button
                      >
                    </div>
                    <b-button v-if="this.user.role == 'admin'" class="mt-2" size="sm" variant="success" @click="startSendOrder('Inscription Booking')">Send Inscription Booking Order</b-button>
                  </b-tab>
                  <b-tab
                    title="Permit"
                    title-link-class="text-success">
                    <template #title>
                      <b-row class="text-center">
                        <b-col>
                          Permit<b-icon v-if="viewedOrder.permitSent != null && viewedOrder.permitSent == true" class="text-center" icon="check-square" scale="1" variant="success"></b-icon>
                        </b-col>
                      </b-row>
                    </template>
                    <p v-if="this.isUploadingFile" style="color: red">
                      Files are being uploaded. Please do not close the page.
                    </p>
                    <b-spinner v-if="isUploadingFile" label="Spinning"></b-spinner>
                    <div v-if="this.viewedOrder.files.length == 0">
                      This event does not have any file yet.
                    </div>
                    <div v-if="this.viewedOrder.files.length > 0" class="file-list mt-2">
                      <div v-for="(file, index) in viewedOrder.files" :key="index">
                        <div v-if="file.fileType == 'permit'">
                          <b-row class="mt-1 ml-1" align-h="between">
                            <div>
                              <b-icon
                                v-if="user.name == viewedOrder.salesName || user.role == 'admin'"
                                class="mt-1 pointer"
                                icon="trash-fill"
                                scale="1"
                                variant="danger"
                                @click="deleteFile(index)"
                              ></b-icon>
                              <span style="color: green; cursor: pointer;text-decoration: underline;" @click="downloadFile(index)">{{ file.fileName }}</span>
                              <span style="color: grey;" v-if="file.uploader != null">uploaded by {{ file.uploader }} on {{ file.uploadDate }} [{{  file.fileType }}]</span>
                            </div>
                          </b-row>
                          <hr class="m-0 p-0" />
                        </div>
                      </div>
                    </div>
                    <div class="fileUploadPanel">
                      <b-form-file
                        class="mt-3"
                        v-model="selectedFile"
                        :state="Boolean(selectedFile)"
                        placeholder="Choose files or drop those here..."
                        drop-placeholder="Drop file here..."
                      ></b-form-file>
                      <div class="mt-3">
                        Selected files: {{ this.selectedFiles.length }}
                      </div>
                      <div>
                        <b-row
                          class="mt-1 ml-1"
                          v-for="(file, index) in selectedFiles"
                          :key="index"
                        >
                          {{ file.name }}
                          <b-icon
                            class="mt-1 ml-1 pointer"
                            icon="x-circle"
                            scale="1"
                            variant="danger"
                            @click="removeFile(index)"
                          ></b-icon>
                        </b-row>
                      </div>
                      <b-button
                        v-if="user.name == viewedOrder.salesName || user.role == 'admin'"
                        :disabled="
                          this.selectedFiles.length == 0 || this.isUploadingFile
                            ? true
                            : false
                        "
                        class="mt-4"
                        block
                        variant="success"
                        @click="uploadFiles('permit')"
                      >
                        Upload</b-button
                      >
                    </div>
                    <b-button v-if="this.user.role == 'admin'" class="mt-2" size="sm" variant="success" @click="startSendOrder('permit')">Send Permit Order</b-button>
                  </b-tab>
                </b-tabs>
              </b-tab>
              <b-tab title="Quote" title-link-class="text-success">
                <b-dropdown
                  v-if="!showQuote"
                  class="mt-2"
                  variant="success"
                  text="Add Quote"
                >
                  <b-dropdown-item @click="crmAddMonumentQuote()">
                    Monument
                    <b-icon icon="plus" scale="1.5" variant="success"></b-icon>
                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="crmAddAdditionalInscriptionQuote()">
                    Additional Inscription
                    <b-icon icon="plus" scale="1.5" variant="success"></b-icon>
                  </b-dropdown-item>
                </b-dropdown>
                <div v-if="showQuote">
                  <span id="view-quote-button">
                    <b-button :disabled="user.name != viewedOrder.salesName  && user.role != 'admin'" class="mt-2" size="sm" variant="success" @click="viewQuote">View Details</b-button>
                  </span>
                  <b-tooltip v-if="user.name != viewedOrder.salesName  && user.role != 'admin'"
                    target="view-quote-button" triggers="hover">
                    Only owner and admin can modify the order
                  </b-tooltip>
                  <div class="mt-2 p-0">
                    <div v-if="quote.materials.length > 0" class="monument bordered">
                      <b-row>
                        <b-col class="quote-item-row-divider-vertical">
                          <strong>Monument</strong>
                        </b-col>
                        <b-col cols="2" class="text-right">
                          <strong>Price</strong>
                        </b-col>
                      </b-row>
                      <b-row v-for="(material, index) in quote.materials" :key="'material' + index">
                        <b-col class="quote-item-row-left">
                          <span v-if="quote.monument_type != null">{{quote.monument_type}} - </span>{{material.name}}<span> - {{material.size}} - {{material.usage}}</span>
                        </b-col> 
                        <b-col class="text-right quote-item-row-right" cols="2">
                          {{material.total_price}}
                        </b-col>
                      </b-row>
                    </div>
                    <div v-if="quote.quote_discount > 0" class="discount bordered">
                      <b-row>
                        <b-col class="quote-item-row-divider-vertical">
                          <strong>Material Discount</strong>
                        </b-col>
                        <b-col cols="2" class="text-right">
                          {{quote.quote_discount}}% off
                        </b-col>
                      </b-row>
                    </div>
                    <div v-if="quote.installations.length > 0" class="Installation bordered">
                      <b-row>
                        <b-col class="quote-item-row-divider-vertical">
                          <strong>Installation</strong>
                        </b-col>
                        <b-col cols="2"></b-col>
                      </b-row>
                      <b-row v-for="(installation, index) in quote.installations" :key="'installation' + index">
                        <b-col class="quote-item-row-left">
                          {{installation.name}}
                        </b-col>
                        <b-col class="text-right quote-item-row-right" cols="2">
                          {{installation.price}}
                        </b-col>
                      </b-row>
                    </div>
                    <div v-if="quote.inscriptions.length > 0" class="Inscription bordered">
                      <b-row>
                        <b-col class="quote-item-row-divider-vertical">
                          <strong>Inscription</strong>
                        </b-col>
                        <b-col cols="2"></b-col>
                      </b-row>
                      <b-row v-for="(inscription, index) in quote.inscriptions" :key="'inscription' + index">
                        <b-col class="quote-item-row-left">
                          {{inscription.name}}
                        </b-col>
                        <b-col class="text-right quote-item-row-right" cols="2">
                          <span v-if="inscription.name == '[Per Letter]Under 40 letters(& included 40 letters)'">
                            200 + 
                          </span>
                          {{inscription.price}} * {{inscription.number}}
                        </b-col>
                      </b-row>
                    </div>
                    <div v-if="quote.accessories.length > 0" class="Accessory bordered">
                      <b-row>
                        <b-col class="quote-item-row-divider-vertical">
                          <strong>Accessory</strong>
                        </b-col>
                        <b-col cols="2"></b-col>
                      </b-row>
                      <b-row v-for="(accessory, index) in quote.accessories" :key="'accessory' + index">
                        <b-col class="quote-item-row-left">
                          {{accessory.name}} - {{accessory.size}} * {{accessory.quantity}}
                        </b-col>
                        <b-col class="text-right quote-item-row-right" cols="2">
                          {{accessory.total_price}}
                        </b-col>
                      </b-row>
                    </div>
                    <div v-if="quote.castings.length > 0" class="Casting bordered">
                      <b-row>
                        <b-col class="quote-item-row-divider-vertical">
                          <strong>Carving</strong>
                        </b-col>
                        <b-col cols="2"></b-col>
                      </b-row>
                      <b-row v-for="(casting, index) in quote.castings" :key="'casting' + index">
                        <b-col class="quote-item-row-left">
                          {{casting.name}}
                        </b-col>
                        <b-col class="text-right quote-item-row-right" cols="2">
                          {{casting.price}}
                        </b-col>
                      </b-row>
                    </div>
                    <div v-if="quote.permit_fee > 0" class="permit-fee bordered">
                      <b-row>
                        <b-col class="quote-item-row-divider-vertical">
                          <strong>Permit Fee</strong>
                        </b-col>
                        <b-col cols="2" class="text-right">
                          {{quote.permit_fee}}
                        </b-col>
                      </b-row>
                    </div>
                    <div v-if="quote.foundations.length > 0" class="Foundation bordered">
                      <b-row>
                        <b-col class="quote-item-row-divider-vertical"> 
                          <strong>Foundation</strong>
                        </b-col>
                        <b-col cols="2"></b-col>
                      </b-row>
                      <b-row v-for="(foundation, index) in quote.foundations" :key="'foundation' + index">
                        <b-col class="quote-item-row-left">
                          {{foundation.name}}
                        </b-col>
                        <b-col class="text-right quote-item-row-right" cols="2">
                          {{foundation.price}}
                        </b-col>
                      </b-row>
                    </div>
                    <div class="extra-fee bordered" v-if="quote.extra_fee != null && quote.extra_fee > 0">
                      <b-row>
                        <b-col class="quote-item-row-divider-vertical">
                          <strong>Extra Fee</strong>
                        </b-col>
                        <b-col  cols="2" class="text-right">
                          {{quote.extra_fee}}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col class="quote-item-row-divider-vertical">
                          {{quote.extra_fee_description}}
                        </b-col>
                        <b-col cols="2"></b-col>
                      </b-row>
                    </div>
                    <div class="total-price bordered">
                      <b-row>
                        <b-col class="quote-item-row-divider-vertical">
                          <strong>Total Price</strong>
                        </b-col>
                        <b-col cols="2" class="text-right">
                          <strong>{{quote.total_price}}</strong>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab class="mt-2" title="Installation" title-link-class="text-success">
                <b-row>
                  <b-col cols="6" v-for="item in viewOrderFormInstallation" :key="item.key">
                    <label :for="`viewed-order-input-${item.key}`">{{item.label}}<span style="color: red" v-if="item.mandatory">*</span></label>
                    <b-form-input size="sm" v-if="item.form_type == 'text-input'" :id="`viewed-order-input-${item.key}`" :type="item.type" v-model="viewedOrder[item.key]" :required="item.mandatory"></b-form-input>
                    <span v-if="item.form_type == 'text-input-list'">
                      <b-form-input :id="`new-order-input-${item.key}`" :type="item.type" v-model="viewedOrder[item.key]" :required="item.mandatory" :list="item.listName"></b-form-input>
                      <datalist :id="item.listName">
                        <option v-for="(option, index) in dataLists[item.listName]" :key="item.label + index">{{ option }}</option>
                      </datalist>
                    </span>
                    <b-form-select size="sm" v-if="item.form_type == 'select'"
                      :id="`viewed-order-input-${item.key}`"
                      v-model="viewedOrder[item.key]" 
                      :required="item.mandatory"
                      :options="selectOptions[item.options]"
                    ></b-form-select>
                    <b-form-datepicker v-if="item.form_type == 'datepicker'"
                      :id="`new-order-input-${item.key}`"
                      v-model.trim="viewedOrder[item.key]" 
                      :required="item.mandatory"
                      today-button
                      reset-button
                      close-button
                    ></b-form-datepicker>
                    <b-form-textarea size="sm"
                      v-if="item.form_type == 'textarea'"
                      id="viewed-order-description"
                      v-model.trim="viewedOrder[item.key]" 
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </b-col>
                </b-row>
                <span id="add-installation-button">
                  <b-dropdown size="sm"
                    class="mt-2"
                    variant="success"
                    text="Add Installation"
                    :disabled="user.name != viewedOrder.salesName && user.role != 'admin'"
                  >
                    <b-dropdown-item @click="crmAddSmallTask()"
                      >Small Task <b-icon icon="plus" scale="1.5" variant="success"></b-icon
                    ></b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="crmAddInstallation()"
                      >Installation
                      <b-icon icon="plus" scale="1.5" variant="success"></b-icon
                    ></b-dropdown-item>
                  </b-dropdown>
                </span>
                <b-tooltip v-if="user.name != viewedOrder.salesName  && user.role != 'admin'" 
                  target="add-installation-button" triggers="hover">
                  Only owner and admin can modify the order
                </b-tooltip>

                <b-table
                  class="pointer mt-2"
                  id="my-table"
                  responsive
                  striped
                  hover
                  @row-clicked="installationRowClickHandler"
                  :fields="installation_fields"
                  :items="installationItems"
                  small>
                </b-table>
              </b-tab>
              <b-tab title="Complaint" title-link-class="text-success">
                <p v-if="this.isUploadingFile" style="color: red">
                  Files are being uploaded. Please do not close the page.
                </p>
                <b-spinner v-if="isUploadingFile" label="Spinning"></b-spinner>
                <div v-if="this.viewedOrder.files.length == 0">
                  This event does not have any file yet.
                </div>
                <div v-if="this.viewedOrder.files.length > 0" class="file-list mt-2">
                  <div v-for="(file, index) in viewedOrder.files" :key="index">
                    <div v-if="file.fileType == 'complaint'">
                      <b-row class="mt-1 ml-1" align-h="between">
                        <div>
                          {{ file.fileName }}
                          <b-icon
                            class="mt-1 pointer"
                            icon="arrow-down"
                            scale="1"
                            variant="success"
                            @click="downloadFile(index)"
                          ></b-icon>
                          <span v-if="file.uploader != null">uploaded by {{ file.uploader }} on {{ file.uploadDate }} [{{ file.fileType }}]</span>
                        </div>
                        <b-icon
                          v-if="user.name == viewedOrder.salesName || user.role == 'admin'"
                          class="mt-1 mr-4 pointer"
                          icon="trash-fill"
                          scale="1"
                          variant="danger"
                          @click="deleteFile(index)"
                        ></b-icon>
                      </b-row>
                      <hr class="m-0 p-0" />
                    </div>
                  </div>
                </div>
                <div class="fileUploadPanel">
                  <b-form-file
                    class="mt-3"
                    v-model="selectedFile"
                    :state="Boolean(selectedFile)"
                    placeholder="Choose files or drop those here..."
                    drop-placeholder="Drop file here..."
                  ></b-form-file>
                  <div class="mt-3">
                    Selected files: {{ this.selectedFiles.length }}
                  </div>
                  <div>
                    <b-row
                      class="mt-1 ml-1"
                      v-for="(file, index) in selectedFiles"
                      :key="index"
                    >
                      {{ file.name }}
                      <b-icon
                        class="mt-1 ml-1 pointer"
                        icon="x-circle"
                        scale="1"
                        variant="danger"
                        @click="removeFile(index)"
                      ></b-icon>
                    </b-row>
                  </div>
                  <!-- <b-progress class="mt-2" v-if="isUploading" :value="progress" :max="max" show-progress animated></b-progress> -->
                  <b-button
                    v-if="user.name == viewedOrder.salesName || user.role == 'admin'"
                    :disabled="
                      this.selectedFiles.length == 0 || this.isUploadingFile
                        ? true
                        : false
                    "
                    class="mt-4"
                    block
                    variant="success"
                    @click="uploadFiles('complaint')"
                  >
                    Upload
                  </b-button>
                  <!-- <b-button v-if="this.isUploadingFile" disabled="true">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                  </b-button> -->
                </div>
                <!-- <span id="add-complaint-button">
                  <b-button :disabled="user.name != viewedOrder.salesName  && user.role != 'admin'" class="mt-2" variant="success" v-b-modal.modal-create-complaint>Add a complaint</b-button>
                </span>
                <b-tooltip v-if="user.name != viewedOrder.salesName  && user.role != 'admin'" 
                  target="add-complaint-button" triggers="hover">
                  Only owner and admin can modify the order
                </b-tooltip>
                <b-card
                  class="mt-2"
                  :title="complaint.complaintDate"
                  :sub-title="`Principal ${complaint.complaintPrincipal}`"
                  v-for="(complaint, index) in this.viewedOrder.complaints"
                  :key="index"
                >
                  <b-card-text>
                    <strong>Content:</strong>
                    <p>{{ complaint.complaintContent }}</p>

                    <strong>How to fix this up?</strong>
                    <p>{{ complaint.complaintSolution }}</p>

                    <strong>What is the final action taken?</strong>
                    <p>{{ complaint.complaintFurtherAction }}</p>
                  </b-card-text>
                </b-card> -->
              </b-tab>
              <b-tab title="Files" title-link-class="text-success">
                <p v-if="this.isUploadingFile" style="color: red">
                  Files are being uploaded. Please do not close the page.
                </p>
                <b-spinner v-if="isUploadingFile" label="Spinning"></b-spinner>
                <div v-if="this.viewedOrder.files.length == 0">
                  This event does not have any file yet.
                </div>
                <div v-if="this.viewedOrder.files.length > 0" class="file-list mt-2">
                  <div v-for="(file, index) in viewedOrder.files" :key="index">
                    <div v-if="file.fileType == 'general' || file.fileType == null">
                      <b-row class="mt-1 ml-1" align-h="between">
                        <div>
                          <b-icon
                            v-if="user.name == viewedOrder.salesName || user.role == 'admin'"
                            class="mt-1 pointer"
                            icon="trash-fill"
                            scale="1"
                            variant="danger"
                            @click="deleteFile(index)"
                          ></b-icon>
                          <span style="color: green; cursor: pointer;text-decoration: underline;" @click="downloadFile(index)">{{ file.fileName }}</span>
                          <span style="color: grey;" v-if="file.uploader != null">uploaded by {{ file.uploader }} on {{ file.uploadDate }}  [{{  file.fileType }}]</span>
                        </div>
                        
                      </b-row>
                      <hr class="m-0 p-0" />
                    </div>
                  </div>
                </div>
                <div class="fileUploadPanel">
                  <b-form-file
                    class="mt-3"
                    v-model="selectedFile"
                    :state="Boolean(selectedFile)"
                    placeholder="Choose files or drop those here..."
                    drop-placeholder="Drop file here..."
                  ></b-form-file>
                  <div class="mt-3">
                    Selected files: {{ this.selectedFiles.length }}
                  </div>
                  <div>
                    <b-row
                      class="mt-1 ml-1"
                      v-for="(file, index) in selectedFiles"
                      :key="index"
                    >
                      {{ file.name }}
                      <b-icon
                        class="mt-1 ml-1 pointer"
                        icon="x-circle"
                        scale="1"
                        variant="danger"
                        @click="removeFile(index)"
                      ></b-icon>
                    </b-row>
                  </div>
                  <!-- <b-progress class="mt-2" v-if="isUploading" :value="progress" :max="max" show-progress animated></b-progress> -->
                  <b-button
                    v-if="user.name == viewedOrder.salesName || user.role == 'admin'"
                    :disabled="
                      this.selectedFiles.length == 0 || this.isUploadingFile
                        ? true
                        : false
                    "
                    class="mt-4"
                    block
                    variant="success"
                    @click="uploadFiles('general')"
                  >
                    Upload</b-button
                  >
                  <!-- <b-button v-if="this.isUploadingFile" disabled="true">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                  </b-button> -->
                </div>
              </b-tab>
              <b-tab title-link-class="text-success">
                <template #title>
                  Comments<!--  <spin name="comments-circled-text" class="circled-text">{{viewedOrder.comments.length}}</spin> -->
                </template>
                <b-button class="mt-2" variant="success" v-b-modal.modal-create-comment>
                  Add a comment
                </b-button>
                <b-card
                  class="mt-2"
                  :title="comment.creater"
                  :sub-title="comment.time"
                  v-for="(comment, index) in viewedOrder.comments"
                  :key="index"
                >
                  <b-card-text>
                    <div>{{ comment.content }}</div>
                    <div>
                      <b-button size="sm" variant="success" @click="editComment(index)">Edit</b-button>
                      <b-button size="sm" class="ml-1" variant="danger" @click="deleteComment(index)">Delete</b-button>
                    </div>
                  </b-card-text>
                </b-card>
              </b-tab>
            </b-tabs>
            <div class="mt-2">
              <b-form-checkbox
                v-model="viewedOrderClosed"
                :value=true
                :unchecked-value=false
              >
                Closed
              </b-form-checkbox>
            </div>
            <div class="mt-2" style="display: flex; justify-content: space-between;">
              <div>
                <b-button class="mr-2" size="sm" variant="success" @click="showModal('crm-order-histories')">History</b-button>
                <b-button class="mr-2" size="sm" variant="success" @click="showModal('crm-order-email-histories')">Email History</b-button>
                <b-button class="mr-2" size="sm" variant="success">File History</b-button>
              </div>
              <div id="update-button-2">
                <b-button v-if="this.user.name == 'Rick' || this.user.name == 'Liz'" class="mr-2" size="sm" variant="danger" @click="showModal('modal-delete-confirmation')">
                  Delete
                </b-button>
                <b-button size="sm" variant="success" type="submit" :disabled="user.name != viewedOrder.salesName  && user.role != 'admin'">
                  <span v-if="!isUpdating">Update</span>
                  <span v-if="isUpdating">
                    <b-spinner small type="grow"></b-spinner>
                    Update...
                  </span>
                </b-button>
              </div>
              <b-tooltip v-if="user.name != viewedOrder.salesName  && user.role != 'admin'"
                target="update-button-2" triggers="hover">
                Only owner and admin can modify the order
              </b-tooltip>
            </div>
            <div class="mt-4">
            </div>
          </b-col>
        </b-row>
      </b-form>

      <!-- SEND ORDER -->
      <b-modal
        id="modal-send-order"
        hide-footer
        title="Send Order"
        size="lg">

        <b-container>
          <b-form @submit.prevent="sendOrder">
            <b-row>
              <b-label>To(Manufacturer) ({{ this.viewedOrder.orderingManufacturer }})</b-label>
              <b-form-input v-model="order_email_to"></b-form-input>
            </b-row>

            <b-row>
              <b-label>From(JSM Email)</b-label>
              <b-form-input v-model="order_email_from"></b-form-input>
            </b-row>

            <b-row>
              <b-label>CC (Use comma to separate emails)</b-label>
              <b-form-input v-model="order_email_cc"></b-form-input>
            </b-row>

            <b-row>
              <b-label>Subject</b-label>
              <b-form-input v-model="order_email_subject"></b-form-input>
            </b-row>

            <b-row>
              <b-label>Body:</b-label>
              <b-form-textarea 
                rows="6" 
                v-model="order_email_body">
              </b-form-textarea>
            </b-row>

            <b-row>
              <p>Select Related Fiels to be attached:</p>
            </b-row>

            <b-row v-for="(file, index) in this.viewedOrder.files" :key="index">
              <b-form-checkbox
                v-model="filesCheckbox[index]"
                :value=true
                :unchecked-value=false
              >
                {{ file.fileName }} [{{ file.fileType }}]
              </b-form-checkbox>
            </b-row>

            <b-row>
              <p>Another email will go to the sales notifying order has been placed.</p>
            </b-row>

            <b-row>
              <b-button type="submit" variant="success" >Send</b-button>
            </b-row>
          </b-form>
        </b-container>
      </b-modal>
      
      <!-- DELETE CONFIRMATION -->
      <b-modal
        id="modal-delete-confirmation"
        hide-footer
        title="Delete Comfirmation"
      >
        <p>
          Are you sure you want to delete {{ this.viewedOrder.invoiceNumber }}?
          The order will be permanently deleted.
        </p>
        <div class="modal-footer">
          <b-button
            variant="primary"
            @click="hideModal('modal-delete-confirmation')"
          >
            Cancel
          </b-button>
          <b-button variant="danger" @click="deleteOrder()"> Delete </b-button>
        </div>
      </b-modal>

      <!-- <b-modal
        id="modal-add-installation"
        hide-footer
        title="Add installation"
      >

      </b-modal> -->

      <!-- ADD COMPLAINT -->
      <b-modal id="modal-create-complaint" hide-footer title="Add a complaint">
        <b-form @submit.prevent="addComplaint">
          <b-row class="mx-2">
            <p class="mb-0" cols="12">Complaint Date:</p>
            <b-form-datepicker
              type="date"
              id="complaint_date"
              v-model="newComplaint.complaintDate"
              class="form-control"
              :required="true"
              cols="12"
              today-button
              reset-button
              close-button
            ></b-form-datepicker>
            <p class="mb-0" cols="12">Complaint Principal:</p>
            <b-form-input
              :required="true"
              type="text"
              id="complain_principal"
              v-model="newComplaint.complaintPrincipal"
              class="form-control"
              placeholder="Principal"
              cols="12"
            ></b-form-input>
            <p class="mb-0" cols="12">Complaint content:</p>
            <b-form-textarea
              id="complaint_content"
              v-model="newComplaint.complaintContent"
              placeholder="Complaint content..."
              rows="3"
              max-rows="6"
              required
            ></b-form-textarea>
            <p class="mb-0" cols="12">Complaint solution:</p>
            <b-form-textarea
              id="complaint_solution"
              v-model="newComplaint.complaintSolution"
              placeholder="Complaint solution..."
              rows="3"
              max-rows="6"
              required
            ></b-form-textarea>
            <p class="mb-0" cols="12">
              What is the fianl action taken?(by whom, on what date)
            </p>
            <b-form-textarea
              id="complaint_furtherAction"
              class="mb-3"
              v-model="newComplaint.complaintFurtherAction"
              placeholder="Further action..."
              rows="3"
              max-rows="6"
              required
            ></b-form-textarea>
          </b-row>
          <div class="modal-footer pb-0">
            <b-button @click="hideModal('modal-create-complaint')">
              Cancel
            </b-button>
            <b-button type="submit" variant="primary">Create</b-button>
          </div>
        </b-form>
      </b-modal>

      <!-- ADD COMMENT -->
      <b-modal id="modal-create-comment" hide-footer title="Add a comment">
        <b-form @submit.prevent="addComment">
          <b-form-textarea
            id="textarea"
            v-model="newComment"
            placeholder="Enter something..."
            rows="3"
            max-rows="6"
            required
          ></b-form-textarea>
          <div class="modal-footer">
            <b-button @click="hideModal('modal-create-comment')">
              Cancel
            </b-button>
            <b-button type="submit" variant="primary">Create</b-button>
          </div>
        </b-form>
      </b-modal>

      <b-modal
        id="file-deletion-confirmation"
        hide-footer
        title="You are deleting a file"
      >
        <p>This file will be permanently deleted.</p>
        <div class="modal-footer">
          <b-button @click="hideModal('file-deletion-confirmation')">
            Cancel
          </b-button>
          <b-button variant="danger" @click="deleteFileTask"> Delete </b-button>
        </div>
      </b-modal>

      <!-- Edit comment -->
      <b-modal id="modal-edit-comment" hide-footer title="Add a comment">
        <b-form @submit.prevent="editCommentTask">
          <b-form-textarea
            id="textarea"
            v-model="viewedComment.content"
            placeholder="Enter something..."
            rows="3"
            max-rows="6"
            required
          ></b-form-textarea>
          <div class="modal-footer">
            <b-button @click="hideModal('modal-edit-comment')">
              Cancel
            </b-button>
            <b-button type="submit" variant="success">Edit</b-button>
          </div>
        </b-form>
      </b-modal>

      <b-modal
        id="file-deletion-confirmation"
        hide-footer
        title="You are deleting a file"
      >
        <p>This file will be permanently deleted.</p>
        <div class="modal-footer">
          <b-button @click="hideModal('file-deletion-confirmation')">
            Cancel
          </b-button>
          <b-button :disabled="isDeleting" variant="danger" @click="deleteFileTask"> 
            <span v-if="!isDeleting" >Delete</span> 
            <span v-if="isDeleting" >Deleting...</span>
          </b-button>
        </div>
      </b-modal>

      <!-- Delete Comment -->
      <b-modal
        id="modal-delete-comment"
        hide-footer
        title="You are deleting a comment"
      >
        <p>This comment will be permanently deleted.</p>
        <div class="modal-footer">
          <b-button @click="hideModal('modal-delete-comment')">
            Cancel
          </b-button>
          <b-button variant="danger" @click="deleteCommentTask"> Delete </b-button>
        </div>
      </b-modal>

      <!-- Order Closed -->
      <b-modal
        id="modal-order-closed"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        >
        <p v-if="this.viewedOrder.status == 'closed'">This order will be marked as unfinished.</p>
        <p v-if="this.viewedOrder.status == null || this.viewedOrder.status == 'active'">This order will be marked as cloesd.</p>
        <div class="modal-footer">
          <b-button @click="cancelClosed()">
            Cancel
          </b-button>
          <b-button variant="success" @click="viewedOrderClosedClickedTask"> Submit </b-button>
        </div>
      </b-modal>

      <!-- Histories -->
      <b-modal
        id="crm-order-histories"
        hide-footer
        title="Histories">
        <div v-for="(item, index) in viewedOrder.histories" :key="'history' + index">
          <div v-b-toggle="'order-history-collapse-' + index">
            {{item.editor.name}} edited on {{item.editDate}}
            <b-icon
              icon="chevron-down"
              scale="1"
              variant="secondary"
            ></b-icon>
          </div>
          <b-collapse v-bind:id="'order-history-collapse-' + index">
            {{item}}
          </b-collapse>
        </div>
      </b-modal>

      <!-- Email Histories -->
      <b-modal
        id="crm-order-email-histories"
        hide-footer
        title="Histories">
        <div v-for="(item, index) in viewedOrder.emailHistories" :key="'email_history' + index">
          <div v-b-toggle="'order-email-history-collapse-' + index">
            {{item.from}} sent on {{item.orderDate}}
            <b-icon
              icon="chevron-down"
              scale="1"
              variant="secondary"
            ></b-icon>
          </div>
          <b-collapse v-bind:id="'order-email-history-collapse-' + index">
            {{item.message.text}}
          </b-collapse>
        </div>
      </b-modal>

      <!-- CREATE NEW ACCESSORY ORDER -->
      <b-modal
        id="modal-create-accessory-order"
        hide-footer
        title="Create Accessary Order"
        size="lg"
        >
        <div>
          <b-row>
            <b-col cols="6" v-for="item in accessoryOrderForm" :key="item.key">
              <label :for="`accessory-order-input-${item.key}`">{{item.label}}:<span v-if="item.mandatory" style="color: red">*</span></label>
              <b-form-input v-if="item.form_type == 'text-input'" :id="`accessory-order-input-${item.key}`" :type="item.type" v-model="viewedAccessoryOrder[item.key]"></b-form-input>
              <b-form-datepicker v-if="item.form_type == 'datepicker'"
                :id="`accessory-order-input-${item.key}`"
                v-model.trim="viewedAccessoryOrder[item.key]" 
                :required="item.mandatory"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
              <b-form-select v-if="item.form_type == 'select'"
                :id="`accessory-order-input-${item.key}`"
                v-model="viewedAccessoryOrder[item.key]" 
                :options="selectOptions[item.options]"
              ></b-form-select>
            </b-col>
          </b-row>
          <div>
            <div class="my-1">Door: <b-button size="sm" @click="addDoorToAccessory">Add Door</b-button></div>
            <b-row class="m-2" v-for="(door, index) in viewedAccessoryOrder.doors" :key="'door' + index">
              <b-col cols="12"><b>Door {{index + 1}}</b></b-col>
              <b-col cols="4" v-for="item in accessoryOrderFormDoorForm" :key="item.key">
                <span v-if="item.key != 'status'">
                  <label :for="`accessory-order-door-input-${item.key}`">{{item.label}}:<span v-if="item.mandatory" style="color: red">*</span></label>
                  <b-form-input v-if="item.form_type == 'text-input'" :id="`viewed-order-input-${item.key}`" :type="item.type" v-model="door[item.key]" :disabled="item.key == 'invoiceNumber'"></b-form-input>
                  <b-form-select v-if="item.form_type == 'select'"
                    :id="`viewed-accessory-order-door-input-${item.key}`"
                    v-model="door[item.key]" 
                    :options="selectOptions[item.options]"
                  ></b-form-select>
                </span>
              </b-col>
              <hr>
            </b-row>
            <div class="my-1">Accessory: <b-button size="sm" @click="addAccessoryToAccessory">Add Accessory</b-button></div>
            <b-row class="m-2" v-for="(accessory, index) in viewedAccessoryOrder.accessories" :key="'accessory' + index">
              <b-col cols="12"><b>Accessory {{index + 1}}</b></b-col>
              <b-col cols="4" v-for="item in accessoryOrderFormAccessoryForm" :key="item.key">
                <span v-if="item.key != 'status'">
                  <label :for="`viewed-order-input-${item.key}`">{{item.label}}:<span v-if="item.mandatory" style="color: red">*</span></label>
                  <b-form-input v-if="item.form_type == 'text-input'" :id="`viewed-order-input-${item.key}`" :type="item.type" v-model="accessory[item.key]" :disabled="item.key == 'invoiceNumber'"></b-form-input>
                </span>
              </b-col>
              <hr>
            </b-row>
          </div>
        </div>
        <div class="modal-footer">
          <b-button @click="hideModal('modal-create-accessory-order')">
            Cancel
          </b-button>
          <b-button variant="success" @click="submitAccessoryOrder"> Submit </b-button>
        </div>
      </b-modal>

      <!-- Edit ACCESSORY ORDER -->
      <b-modal
        id="modal-edit-accessory-order"
        hide-footer
        title="Edit Accessary Order"
        size="lg"
        >
        <div>
          <b-button variant="success" @click="exportAccessoryOrder">Export for printing</b-button>
          <b-row>
            <b-col cols="6" v-for="item in accessoryOrderForm" :key="item.key">
              <label :for="`accessory-order-input-${item.key}`">{{item.label}}:<span v-if="item.mandatory" style="color: red">*</span></label>
              <b-form-input v-if="item.form_type == 'text-input'" :id="`accessory-order-input-${item.key}`" :type="item.type" v-model="viewedAccessoryOrder[item.key]"></b-form-input>
              <b-form-datepicker v-if="item.form_type == 'datepicker'"
                :id="`accessory-order-input-${item.key}`"
                v-model.trim="viewedAccessoryOrder[item.key]" 
                :required="item.mandatory"
                today-button
                reset-button
                close-button
              ></b-form-datepicker>
              <b-form-select v-if="item.form_type == 'select'"
                :id="`accessory-order-input-${item.key}`"
                v-model="viewedAccessoryOrder[item.key]" 
                :options="selectOptions[item.options]"
              ></b-form-select>
            </b-col>
          </b-row>
          <div>
            <div class="my-1">Door: <b-button size="sm" @click="addDoorToAccessory">Add Door</b-button></div>
            <b-row class="m-2" v-for="(door, index) in viewedAccessoryOrder.doors" :key="'door' + index">
              <b-col cols="12"><b>Door {{index + 1}}</b></b-col>
              <b-col cols="4" v-for="item in accessoryOrderFormDoorForm" :key="item.key">
                <label :for="`viewed-accessory-order-door-input-${item.key}`">{{item.label}}:<span v-if="item.mandatory" style="color: red">*</span></label>
                <b-form-input v-if="item.form_type == 'text-input'" :id="`viewed-order-input-${item.key}`" :type="item.type" v-model="door[item.key]" :disabled="item.key == 'invoiceNumber'"></b-form-input>
                <b-form-select v-if="item.form_type == 'select'"
                  :id="`viewed-accessory-order-door-input-${item.key}`"
                  v-model="door[item.key]" 
                  :options="selectOptions[item.options]"
                ></b-form-select>
              </b-col>
              <hr>
            </b-row>
            <div class="my-1">Accessory: <b-button size="sm" @click="addAccessoryToAccessory">Add Accessory</b-button></div>
            <b-row class="m-2" v-for="(accessory, index) in viewedAccessoryOrder.accessories" :key="'accessory' + index">
              <b-col cols="12"><b>Accessory {{index + 1}}</b></b-col>
              <b-col cols="4" v-for="item in accessoryOrderFormAccessoryForm" :key="item.key">
                <label :for="`viewed-accessory-order-accessory-input-${item.key}`">{{item.label}}:<span v-if="item.mandatory" style="color: red">*</span></label>
                <b-form-input v-if="item.form_type == 'text-input'" :id="`viewed-order-input-${item.key}`" :type="item.type" v-model="accessory[item.key]" :disabled="item.key == 'invoiceNumber'"></b-form-input>
                <b-form-select v-if="item.form_type == 'select'"
                  :id="`viewed-accessory-order-accessory-input-${item.key}`"
                  v-model="accessory[item.key]" 
                  :options="selectOptions[item.options]"
                ></b-form-select>
              </b-col>
              <hr>
            </b-row>
          </div>
        </div>
        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-accessory-order')">
            Cancel
          </b-button>
          <b-button variant="success" @click="updateAccessoryOrder"> 
            <span v-if="!isUpdating">Update</span>
            <b-spinner v-if="isUpdating" small type="grow"></b-spinner>
          </b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
// import { BIconHandThumbsDown } from "bootstrap-vue";
import firebase from "firebase/app";

export default {
  data() {
    return {
      exportAccessoryOrderMode: false,
      viewedDocRef: {},
      isDeleting: false,
      skipFirstCloesdWatch: true,
      cancelClosedTriggered: false,
      viewedOrderClosed: null,
      viewedComment: {},
      viewedCommentIndex: 0,
      sentOrderType: '',
      filesCheckbox: [],
      order_email_to: "147470028@qq.com",
      // order_email_to: 'rick@johnstonemart.com',
      order_email_from: "lizqiu@johnstonemart.com",
      // order_email_from: 'rick@johnstonemart.com',
      order_email_cc: "",
      order_email_subject: "",
      order_email_body: "你好，\n收到订单请马上回复确认，如确认可以加工此订单请点击以下链接。\n\n 如不能加工此订单请回复告知。\n\n商祺!\n\n澳洲石材超市\n\n如果是墓碑订单请注意一下特殊要求：\n\n1. 正常订单交货期为42天\n2. 请检查好图纸部件的各个尺寸，寸发表的尺寸一定要和图纸吻合，如发现不吻合请马上告知\n3. 石头不能有石斑及色差\n4. 墓碑需要打安装孔和安装槽\n5. 发货前务必要拼装，包括花瓶的摆放，出现过花瓶底部尺寸做大了，没法放在指  定的位置上\n6. 确认安装孔位置正确，保证我们的安装工作能顺利完成。\n7. 请在每个部件（不抛光的面）上写上订单号\n8. 底座单独包装，务必在每个底座上写上订单号\n9. 请在保证装箱的安全的情况下，把需要刻字的部件等放在木箱的最上面而且面朝上。",
      job_styles: [],
      funeralServiceProviderNames: [],
      showQuote: false,
      quote: {
        accessories: [],
        accessory_doors:[],
        accessory_others:[],
        accessory_photos:[],
        castings:[],
        create_date: "",
        create_day: 0,
        create_year_month: "",
        created_by: {},
        created_by_name: "",
        customer_cemetery: "",
        customer_comment: "",
        customer_email: "",
        customer_funeral_provider: "",
        customer_grave_number: "",
        customer_how_find: "",
        customer_name: "",
        customer_phone: "",
        customer_row: "",
        customer_section: "",
        extra_fee: 0,
        extra_fee_description: "",
        failed_reason: "",
        foundations: [],
        id: "",
        inscriptions: [],
        installations: [],
        materials: [],
        monument_style: "",
        monument_type: "",
        no_of_items: 0,
        orderId: "",
        permit_fee: "",
        quote_discount: 0,
        status: "",
        total_price: "",
        type: "",
      },
      isUploadingFile: false,
      files: [],
      selectedFile: null,
      selectedFiles: [],
      deletedFileIndex: "",
      uploadedFileNames: [],
      uploadedFiles: [],
      newComment: "",
      installationItems: [],
      viewedAccessoryOrder: {
        to: "",
        date: "",
        storeLocation: "",
        salesPerson: this.user.name,
        doors: [],
        accessories: [],
      },
      viewedOrder: {
        docketNumber: "",
        address: "",
        ashlarDoneDate: "",
        ashlarInstaller: "",
        cemetery: "",
        comments: [],
        complaints: [],
        createDate: "",
        createDateTimestamp: null,
        creater: this.user,
        customerFirstName: "",
        customerLastName: "",
        customerTitle: "",
        deceasedName: "",
        description: "",
        email: "",
        emailHistories: [],
        fileHistories: [],
        files: [],
        finalPaymentDate: "",
        firstPaymentDate: "",
        funeralServiceProvider: "",
        grave: "",
        histories: [],
        id: "",
        inscriptionDoneDate: "",
        inscriptionInstaller: "",
        installationNote: "",
        installations: [],
        invoiceDate: "",
        invoiceNumber: "",
        invoiceTime: null,
        itemCode: "",
        leadSource: "",
        monumentDoneDate: "",
        monumentInstaller: "",
        orderingATA: "",
        orderingConfirmDate: "",
        orderingContainerNumber1: "",
        orderingContainerNumber2: "",
        orderingContainerNumber3: "",
        orderingCrateNumber1: "",
        orderingCrateNumber2: "",
        orderingCrateNumber3: "",
        orderingDispatchDate: "",
        orderingETA: "",
        orderingInscriptionToFactory: "",
        orderingManufacturer: "",
        orderingOrderDate: "",
        orderingStoreLocation: "",
        orderingUnloadStore: "",
        outstandingAmount: 0,
        phone: "",
        postcode: "",
        row: "",
        sales: null,
        salesName: this.user.name,
        secondPaymentDate: "",
        section: "",
        state: "",
        status: "",
        style: "",
        suburb: "",
        totalAmount: 0,
      },
      newComplaint: {
        complaintDate: "",
        complaintPrincipal: "",
        complaintContent: "",
        complaintSolution: "",
        complaintFurtherAction: "",
      },
      manufacturers: [
        {
          name: 'LY',
          email: '147470028@qq.com',
        }, 
        {
          name: 'DS',
          email: 'hansen@dashengstone.com.au',
        }, 
        {
          name: 'Wuzhiping',
          email: 'wuzp_061118@163.com',
        },
        {
          name: 'Jialilai',
          email: 'jialilai-jim@163.com ',
        }
      ],
      manufacturerNames: [],
      storeLocations: [],
      storeLocationNames: [],
      salesNames: [],
      leadSourceNames: [],
      leadSources: [],
      isUpdating: false,
      exportAccessoryOrderDoorFields: [
        { key: "itemCode", label: "itemCode" },
        { key: "size", label: "Size" },
        { key: "frameColor", label: "Frame Color" },
        { key: "perspexColor", label: "Perspex Color" },
        { key: "qty", label: "Qty" },
        { key: "invoiceNumber", label: "Invoice Number" },
        { key: "price", label: "Price Exclusive Gst" },
      ],
      exportAccessoryOrderAccessoryFields: [
        { key: "itemCode", label: "Supplier Item Code" },
        { key: "description", label: "Accessory Description" },
        { key: "qty", label: "Qty" },
        { key: "invoiceNumber", label: "Invoice Number" },
        { key: "price", label: "Price Exclusive Gst" }
      ],
      installation_fields: [
        { key: "start_date", label: "Start Date" },
        { key: "due_date", label: "Due Date" },
        { key: "installation_staff_name", label: "Installation" },
        { key: "sales_name", label: "Sales" },
        { key: "type", label: "Type" },
        { key: "cemetery", label: "Cemetery" },
        { key: "status", label: "Status" },
      ],
      viewOrderFormBasicInputs: [
        { key: "customerTitle", label: "Title", type: "text", form_type: "text-input", mandatory: false },
        { key: "customerFirstName", label: "First Name", type: "text", form_type: "text-input", mandatory: true },
        { key: "customerLastName", label: "Last Name", type: "text", form_type: "text-input", mandatory: true },
        { key: "phone", label: "Phone", type: "text", form_type: "text-input", mandatory: false },
        { key: "email", label: "Email", type: "text", form_type: "text-input", mandatory: false },
        { key: "address", label: "Address", type: "text", form_type: "text-input", mandatory: false },
        { key: "suburb", label: "Suburb", type: "text", form_type: "text-input-list", listName: "suburbList", mandatory: true },
        { key: "state", label: "State", type: "text", form_type: "text-input", mandatory: false },
        { key: "postcode", label: "Postcode", type: "text", form_type: "text-input", mandatory: false },
        { key: "deceasedName", label: "Deceased Name", type: "text", form_type: "text-input", mandatory: false },
        { key: "funeralServiceProvider", label: "Funeral Service Provider", type: "text", form_type: "select", options: 'funeralServiceProviderNames', mandatory: true },
        { key: "leadSource", label: "Lead Source", type: "text", form_type: "select",  options:'leadSourceNames', mandatory: true },
        { key: "salesName", label: "Sales", type: "text", form_type: "select", options:'salesNames', mandatory: true},
        { key: "description", label: "Description", type: "text", form_type: "textarea", mandatory: true },
      ],
      viewOrderFormAccounting: [
        { key: "invoiceNumber", label: "Invoice Number", type: "text", form_type: "text-input", mandatory: true },
        { key: "docketNumber", label: "Docket Number", type: "text", form_type: "text-input", mandatory: false },
        { key: "invoiceDate", label: "Invoice Date", type: "text", form_type: "datepicker", mandatory: true },
        { key: "itemCode", label: "Item Code", type: "text", form_type: "text-input", mandatory: false },
        { key: "totalAmount", label: "Total Amount", type: "text", form_type: "text-input", mandatory: true },
        { key: "firstPaymentDate", label: "1st Payment Date", type: "text", form_type: "datepicker", mandatory: false },
        { key: "secondPaymentDate", label: "2nd Payment Date", type: "text", form_type: "datepicker", mandatory: false },
        { key: "finalPaymentDate", label: "Final Payment Date", type: "text", form_type: "datepicker", mandatory: false },
        { key: "outstandingAmount", label: "Outstanding Amount", type: "text", form_type: "text-input", mandatory: true },
      ],
      viewOrderFormOrdering: [
        { key: "orderingManufacturer", label: "Manufacturer", type: "text", form_type: "select", options: "manufacturerNames", mandatory: false },
        { key: "orderingInscriptionToFactory", label: "Inscription to Factory", type: "text", form_type: "select", options: "inscriptionToFactoryOptions", mandatory: false },
        { key: "orderingStoreLocation", label: "Store Location", type: "text", form_type: "select", options: "storeLocationNames", mandatory: false },
        { key: 'invoiceDate', label: 'Invoice Date', type: 'text', form_type: 'datepicker', mandatory: false},
        { key: "orderDate", label: "Order Date", type: "text", form_type: "datepicker", mandatory: false},
        { key: "orderingConfirmDate", label: "Order Confirm Date", type: "text", form_type: "datepicker", mandatory: false },
        { key: "orderingETA", label: "ETA", type: "text", form_type: "text-input", mandatory: false },
        { key: "orderingContainerNumber1", label: "Container1 #", type: "text", form_type: "text-input", mandatory: false },
        { key: "orderingCrateNumber1", label: "Crate1 #", type: "text", form_type: "text-input", mandatory: false },
        { key: "orderingContainerNumber2", label: "Container2 #", type: "text", form_type: "text-input", mandatory: false },
        { key: "orderingCrateNumber2", label: "Crate2 #", type: "text", form_type: "text-input", mandatory: false },
        { key: "orderingContainerNumber3", label: "Container3 #", type: "text", form_type: "text-input", mandatory: false },
        { key: "orderingCrateNumber3", label: "Crate3 #", type: "text", form_type: "text-input", mandatory: false },
        { key: "orderingUnloadStore", label: "Unload Store", type: "text", form_type: "select", options: "storeLocationNames", mandatory: false },
        { key: "orderingDispatchDate", label: "Dispatch Date", type: "text", form_type: "datepicker", mandatory: false },
        { key: "orderingATA", label: "ATA", type: "text", form_type: "datepicker", mandatory: false },
      ],
      viewOrderFormInstallation: [
        { key: "cemetery", label: "Cemetery", type: "text", form_type: "select", options:'cemeteries', mandatory: false },
        { key: "section", label: "Section", type: "text", form_type: "text-input-list", listName: "sectionList", mandatory: false },
        { key: "row", label: "Row", type: "text", form_type: "text-input", mandatory: false },
        { key: "grave", label: "Grave", type: "text", form_type: "text-input", mandatory: false },
        { key: "style", label: "Style", type: "text", form_type: "select", options:'jobStyles', mandatory: false },
        { key: "foundation", label: "Foundation", type: "text", form_type: "select", options:'foundations', mandatory: false },
        { key: "ashlarDoneDate", label: "Ashlar Done Date", type: "text", form_type: "datepicker", mandatory: false},
        { key: "ashlarInstaller", label: "Ashlar Installer", type: "text", form_type: "select", options:'installer_names', mandatory: false},
        { key: "monumentDoneDate", label: "Monument Done Date", type: "text", form_type: "datepicker", mandatory: false},
        { key: "monumentInstaller", label: "Monument Installer", type: "text", form_type: "select", options:'installer_names', mandatory: false},
        { key: "inscriptionDoneDate", label: "Inscription Done Date", type: "text", form_type: "datepicker", mandatory: false},
        { key: "installationNote", label: "Installation Note", type: "text", form_type: "textarea", mandatory: false},
      ],
      accessoryOrderForm: [
        { key: "to", label: "To", type: "text", form_type: "text-input", mandatory: false },
        { key: "date", label: "Date", type: "text", form_type: "datepicker", mandatory: false },
        { key: "storeLocation", label: "Store Location", type: "text", form_type: "select", options: "storeLocationNames", mandatory: false },
        { key: "salesPerson", label: "Sales Person", type: "text", form_type: "select", options:'salesNames', mandatory: false },
      ],
      accessoryOrderFormDoorForm: [
        { key: "itemCode", label: "Item Code", type: "text", form_type: "text-input", mandatory: true },
        { key: "size", label: "Size", type: "text", form_type: "text-input", mandatory: false },
        { key: "frameColor", label: "Frame Color", type: "text", form_type: "select", options: "frameColorOptions", mandatory: false },
        { key: "perspexColor", label: "Perspex Color", type: "text", form_type: "select", options: "perspexColorOptions", mandatory: false },
        { key: "qty", label: "Qty", type: "text", form_type: "text-input", mandatory: false },
        { key: "invoiceNumber", label: "Invoice Number", type: "text", form_type: "text-input", mandatory: false },
        { key: "status", label: "Status", type: "text", form_type: "select", options:'accessortStatuses', mandatory: false },
      ],
      accessoryOrderFormAccessoryForm: [
        { key: "itemCode", label: "Supplier Item Code", type: "text", form_type: "text-input", mandatory: true },
        { key: "description", label: "Accessory Description", type: "text", form_type: "text-input", mandatory: false },
        { key: "qty", label: "Qty", type: "text", form_type: "text-input", mandatory: false },
        { key: "invoiceNumber", label: "Invoice Number", type: "text", form_type: "text-input", mandatory: false },
        { key: "status", label: "Status", type: "text", form_type: "select", options:'accessortStatuses', mandatory: false },
      ],
      addInstallationType: '',
    }
  },
  props: {
    crmViewedOrderId: String,
    user: Object,
    from: String,
    today: String,
    dataLists: Object,
    selectOptions: Object,
    sales: Array,
  },
  watch: {
    selectedFile(newSelectedFile) {
      if (this.selectedFile != null) {
        this.selectedFiles.push(newSelectedFile);
      }
    },
    viewedOrderClosed() {
      if (this.skipFirstCloesdWatch) {
        this.skipFirstCloesdWatch = false;
        return;
      }

      if (this.cancelClosedTriggered) {
        this.cancelClosedTriggered = false;
        return;
      } else {
        this.showModal('modal-order-closed');
      }
    },
  },
  created() {
    this.viewedDocRef = firebase.firestore().collection('crm_orders').doc(this.crmViewedOrderId);

    this.viewedDocRef.onSnapshot((doc) => {
      this.viewedOrder = doc.data();

      if (this.viewedOrder.orderingInscriptionToFactory == null) {
        this.viewedOrder.orderingInscriptionToFactory = "";
      }

      console.log(this.viewedOrder);

      this.initiateConfig();

      this.order_email_subject = '#' + this.viewedOrder.invoiceNumber + ' 订单 Order';
      this.filesCheckbox = Array(30).fill(false);

      firebase.firestore().collection('events').where('orderId', '==', this.viewedOrder.id).onSnapshot((collection) => {
        this.items = collection.docs.map(doc => doc.data());
        this.installationItems = [];
        for (var i = 0; i < this.items.length; i++) {
          this.installationItems.push(this.items[i]);
        }
      });

      firebase.firestore().collection('quotes').where('orderId', '==', this.viewedOrder.id).onSnapshot((collection) => {
        var items = collection.docs.map(doc => doc.data());
        for (var i = 0; i < items.length; i++) {
          this.quote = items[i];
          this.showQuote = true;
        }
      });
    });

    console.log(this.crmViewedOrderId);

    // firebase.firestore().collection('parameters').doc('manufacturers').get((doc) => {
    //   this.manufacturers = doc.data();
    // });
  },
  methods: {
    printAccessoryOrder() {
      window.print();
    },
    exportAccessoryOrder() {
      this.exportAccessoryOrderMode = true;
    },
    quitExportMode() {
      this.exportAccessoryOrderMode = false;
    },
    createAccessoryOrderButtonClicked() {
      this.viewedAccessoryOrder = {
        to: "",
        date: "",
        storeLocation: "",
        salesPerson: "",
        doors: [],
        accessories: [],
      }
      this.showModal('modal-create-accessory-order');
    },
    updateAccessoryOrder() {
      firebase.firestore().collection("crm_orders").doc(this.viewedOrder.id)
        .set({accessoryOrders: this.viewedOrder.accessoryOrders},
          {merge: true}, (error) => {
            alert('Data could not be saved.' + error)
            this.isUpdating = false;
          })
        .then(() => {
          alert("Update successfully.");
        });
    },
    viewAccessoryOrder(order) {
      console.log(order);
      this.viewedAccessoryOrder = order;
      this.showModal("modal-edit-accessory-order");
    },
    submitAccessoryOrder() {
      if (this.viewedOrder.accessoryOrders == null) {
        this.viewedOrder.accessoryOrders = [];
      }
      this.viewedOrder.accessoryOrders.push(this.viewedAccessoryOrder);
      firebase.firestore().collection("crm_orders").doc(this.viewedOrder.id)
        .set(this.viewedOrder,
          {merge: true}, (error) => {
            alert('Data could not be saved.' + error)
            this.isUpdating = false;
          })
        .then(() => {

          var email_subject = "";
          var email_recipients = [];
          email_recipients.push(this.viewedOrder.sales.email);
          email_subject = "#" + this.viewedOrder.invoiceNumber + " - An accessory order has been uploaded"
          email_recipients.push('sales@johnstonemart.com');
          email_recipients.push('rick@johnstonemart.com');
          email_recipients.push('Ivy@johnstonemart.com');

          let notification_email = {
            from: 'info@johnstonemart.com',
            to: email_recipients,
            message: {
              subject: email_subject,
              text: '#' + this.viewedOrder.invoiceNumber +': An accessory order has been placed by ' + this.user.name + ' on ' + this.today + '\n\n',
            }
          }

          for(let i = 0; i < this.viewedAccessoryOrder.doors.length; i++) {
            let door = this.viewedAccessoryOrder.doors[i];
            notification_email.message.text += "Item Code: " + door.itemCode + "\n"
            + "Size: " + door.itemCode + "\n"
            + "Frame Color: " + door.frameColor + "\n"
            + "Perspex Color: " + door.perspexColor + "\n"
            + "Qty: " + door.qty + "\n"
            + "Price: " + door.price +"\n"
            + "Warehouse Location: " + door.warehouseLocation + '\n\n'
          }

          for(let i = 0; i < this.viewedAccessoryOrder.accessories.length; i++) {
            let accessory = this.viewedAccessoryOrder.accessories[i];
            notification_email.message.text += "Item Code: " + accessory.itemCode + "\n"
            + "Description: " + accessory.description + "\n"
            + "Qty: " + accessory.qty + "\n"
            + "Price: " + accessory.price + "\n"
            + "Warehouse Location: " + accessory.warehouseLocation + "\n\n"
          }

          const mail_ref = firebase.firestore().collection('mail').doc();
          mail_ref.set(notification_email);

          this.viewedAccessoryOrder = {
            to: "",
            date: "",
            storeLocation: "",
            salesPerson: "",
            doors: [],
            accessories: [],
          }
          this.hideModal("modal-create-accessory-order");

          alert("Submit Successfully.");
        });
    },
    addDoorToAccessory() {
      this.viewedAccessoryOrder.doors.push({
        itemCode: "",
        size: "",
        frameColor: "",
        perspexColor: "",
        qty: "",
        invoiceNumber: this.viewedOrder.invoiceNumber,
        price: "",
        warehouseLocation: "",
        status: "processing",
      });
      console.log(this.viewedAccessoryOrder.doors);
    },
    addAccessoryToAccessory() {
      this.viewedAccessoryOrder.accessories.push({
        itemCode: "",
        description: "",
        qty: "",
        invoiceNumber: this.viewedOrder.invoiceNumber,
        price: "",
        warehouseLocation: "",
        status: "processing",
      });
    },
    cancelClosed() {
      this.cancelClosedTriggered = true;
      this.viewedOrderClosed = !this.viewedOrderClosed;
      this.hideModal('modal-order-closed');
    },
    viewedOrderClosedClickedTask() {
      if ((this.viewedOrder.status == null || this.viewedOrder.status == "active")) {
        this.viewedOrder.status = 'closed';
        this.viewedOrderClosed = true;
      } else if (this.viewedOrder.status == "closed") {
        this.viewedOrder.status = 'active';
        this.viewedOrderClosed = false;
      }

      firebase.firestore().collection("crm_orders").doc(this.viewedOrder.id)
        .set({status: this.viewedOrder.status}, {merge: true});

      this.hideModal('modal-order-closed');
    },
    editComment(index) {
      this.viewedCommentIndex = index;
      this.viewedComment = this.viewedOrder.comments[index];
      this.showModal('modal-edit-comment');
    },
    editCommentTask() {
      this.viewedOrder.comments[this.viewedCommentIndex] = this.viewedComment;
      firebase.firestore().collection("crm_orders").doc(this.viewedOrder.id)
          .set({comments: this.viewedOrder.comments},
            {merge: true})
          .then(() => {
            alert('Edit successfully.');
          });
      this.hideModal('modal-edit-comment');
    },
    deleteComment(index) {
      this.viewedCommentIndex = index;
      this.showModal('modal-delete-comment');
    },
    deleteCommentTask() {
      this.viewedOrder.comments.splice(this.viewedCommentIndex, 1);
      firebase.firestore().collection("crm_orders").doc(this.viewedOrder.id)
        .set({comments: this.viewedOrder.comments},
          {merge: true})
        .then(() => {
          alert('Delete successfully.');
        });
      this.hideModal('modal-delete-comment');
    },
    startSendOrder(type) {
      this.showModal('modal-send-order');
      this.sentOrderType = type;
      if (type == 'Stone Order') {
        this.order_email_cc = "jacky@johnstonemart.com, lizqiu@johnstonemart.com"
        switch(this.viewedOrder.orderingManufacturer) {
          case 'LY':
            this.order_email_to = '147470028@qq.com';
            break;
          case 'DS':
            this.order_email_to = 'hansen@dashengstone.com.au';
            break;
          case 'Wuzhiping':
            this.order_email_to = 'wuzp_061118@163.com';
            break;
          case 'Jialilai':
            this.order_email_to = 'jialilai-jim@163.com ';
            break;
          default: 
            break;
        }
      }
    },
    sendOrder() {
      var email_recipients = [this.order_email_to];
      if (this.order_email_cc.length > 0) {
        var cc_list = this.order_email_cc.split(',');
        for ( const cc in cc_list) {
          email_recipients.push(cc_list[cc].trim());
        }
        console.log(email_recipients);
      }

      var attachments = [];
      for (var i = 0; i < this.viewedOrder.files.length; i++) {
        if (this.filesCheckbox[i]) {
          attachments.push(
            {
              filename: this.viewedOrder.files[i].fileName,
              path: this.viewedOrder.files[i].fileURL
            }
          );
        }
      }

      var orderEmail = {
        from: this.order_email_from,
        to: email_recipients,
        message: {
          subject: this.order_email_subject,
          text: this.order_email_body,
          attachments: attachments,
        },
      };

      var notification_email = {
        from: "info@johnstonemart.com",
        to: this.viewedOrder.sales.email,
        message: {
          subject: this.viewedOrder.invoiceNumber + " - A " + this.sentOrderType + " has been sent",
          text: this.user.name + 'has sent a ' + this.sentOrderType + ' on ' + this.today,
        },
      };

      firebase
        .firestore()
        .collection("mail")
        .add(orderEmail);

      firebase
        .firestore()
        .collection("mail")
        .add(notification_email);

      this.hideModal('modal-send-order');
      this.filesCheckbox = Array(30).fill(false);

      // firebase.firestore().collection("crm_orders").doc(this.viewedOrder.id)
      //     .set({orderDate: this.today},
      //       {merge: true});
      // this.viewedOrder.orderDate = this.today;

      orderEmail.from = this.user.name;
      orderEmail.orderDate = this.today;
      this.viewedOrder.emailHistories.push(orderEmail);
      if (this.sentOrderType == 'Stone Order') {
        this.viewedOrder.stoneOrderSent = true;
        firebase.firestore().collection("crm_orders").doc(this.viewedOrder.id)
          .set({emailHistories: this.viewedOrder.emailHistories,
                stoneOrderSent: true},
            {merge: true});
      } else if (this.sentOrderType == 'Purchase Order') {
        this.viewedOrder.purchaseOrderSent = true;
        firebase.firestore().collection("crm_orders").doc(this.viewedOrder.id)
          .set({emailHistories: this.viewedOrder.emailHistories,
                purchaseOrderSent: true},
            {merge: true});
      } else if (this.sentOrderType == 'Inscription Booking') {
        this.viewedOrder.inscriptionBookingSent = true;
        firebase.firestore().collection("crm_orders").doc(this.viewedOrder.id)
          .set({emailHistories: this.viewedOrder.emailHistories,
                inscriptionBookingSent: true},
            {merge: true});
      }

      alert('The order email has been sent!');
    },
    addComplaint() {
      this.viewedOrder.complaints.push(this.newComplaint);
      firebase.firestore().collection("crm_orders").doc(this.viewedOrder.id)
        .set(this.viewedOrder,
          {merge: true})
        .then(() => {
          alert("Modify successfully");
          this.isUpdating = false;
        });
      this.hideModal('modal-create-complaint');
    },
    addComment() {
      var formatted_date = new Date().toJSON().slice(0, 10);
      this.viewedOrder.comments.splice(0, 0, {
        content: this.newComment,
        creater: this.user.name,
        time: formatted_date,
      });
      var self = this;

      var orderRef = firebase
        .firestore()
        .collection("crm_orders")
        .doc(self.viewedOrder.id);

      orderRef
        .set({ comments: self.viewedOrder.comments }, { merge: true })
        .then(() => {
          console.log("Document successfully updated!");
          self.$bvModal.hide("modal-create-comment");
        })
        .catch((error) => {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });

      // const recipient_email =
      //   this.user.role == "sales"
      //     ? this.viewedOrder.installation_staff.email
      //     : this.viewedOrder.sales.email;
      // const recipient_name =
      //   this.user.role == "sales"
      //     ? this.viewedOrder.installation_staff.name
      //     : this.viewedOrder.sales.name;
      var commentEmail = {
        from: 'info@johnstonemart.com',
        to: [this.viewedOrder.sales.email],
        message: {
          subject: this.user.name + " has left a comment<No reply>",
          text:
            "Hi, \n" +
            this.newComment +
            "\nInvoice number: " +
            this.viewedOrder.invoiceNumber
        },
      };

      firebase
        .firestore()
        .collection("mail")
        .add(commentEmail);
    },
    installationRowClickHandler(item){
      console.log(item);
      this.$emit("showEventDetails", {
        event: item,
        from: "CRMOrderDetails",
      });
    },
    viewQuote() {
      this.$emit('viewQuote', {quote: this.quote, from: 'Quotes'});
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    initiateConfig() {
      //Initiate status
      if ((this.viewedOrder.status == null || this.viewedOrder.status == "active")) {
        this.viewedOrderClosed = false;
      } else if (this.viewedOrder.status == "closed") {
        this.viewedOrderClosed = true;
      }
    },
    editOrderTask() {
      if (this.viewedOrder.invoiceDate != null && this.viewedOrder.invoiceDate.length > 0) {
        this.viewedOrder.invoiceTime = new Date(this.viewedOrder.invoiceDate);
      }
      this.isUpdating = true;
      // console.log(this.selectOptions);
      this.viewedOrder.sales = this.sales[this.selectOptions.salesNames.indexOf(this.viewedOrder.salesName)];
      if (this.viewedOrder.suburb != null && this.viewedOrder.suburb.length > 0) this.viewedOrder.suburb = this.viewedOrder.suburb[0].toUpperCase() + this.viewedOrder.suburb.slice(1);
      if (this.viewedOrder.section != null && this.viewedOrder.section.length > 0) this.viewedOrder.section = this.viewedOrder.section[0].toUpperCase() + this.viewedOrder.section.slice(1);
      if (this.viewedOrder.finalPaymentDate != null && this.viewedOrder.finalPaymentDate.length > 0) this.viewedOrder.outstandingAmount = 0;
      if (this.viewedOrder.ashlarInstaller == null) this.viewedOrder.ashlarInstaller = "";
      if (this.viewedOrder.monumentInstaller == null) this.viewedOrder.monumentInstaller = "";

      const tempOrder = Object.assign({}, this.viewedOrder);
      delete tempOrder.histories;
      tempOrder.editor = this.user;
      tempOrder.editDate = this.today;
      this.viewedOrder.histories.push(tempOrder);
      // console.log(this.viewedOrder);

      const viewedSimplifiedOrderRef = firebase.firestore().collection("crm_orders_simplified").doc(this.viewedOrder.id);
      let viewedSimplifiedOrder = {
        id: this.viewedOrder.id? this.viewedOrder.id : "",
        cemetery: this.viewedOrder.cemetery? this.viewedOrder.cemetery : "", 
        customerFirstName: this.viewedOrder.customerFirstName? this.viewedOrder.customerFirstName : "", 
        customerLastName: this.viewedOrder.customerLastName? this.viewedOrder.customerLastName : "",
        deceasedName: this.viewedOrder.deceasedName? this.viewedOrder.deceasedName : "", 
        invoiceNumber: this.viewedOrder.invoiceNumber? this.viewedOrder.invoiceNumber : "", 
        salesName: this.viewedOrder.salesName? this.viewedOrder.salesName : "", 
        style: this.viewedOrder.style? this.viewedOrder.style : "", 
        section: this.viewedOrder.section? this.viewedOrder.section : "", 
        orderingContainerNumber1: this.viewedOrder.orderingContainerNumber1? this.viewedOrder.orderingContainerNumber1 : "", 
        orderingContainerNumber2: this.viewedOrder.orderingContainerNumber2? this.viewedOrder.orderingContainerNumber2 : "", 
        orderingContainerNumber3: this.viewedOrder.orderingContainerNumber3? this.viewedOrder.orderingContainerNumber3 : "", 
        invoiceDate: this.viewedOrder.invoiceDate? this.viewedOrder.invoiceDate : "", 
        orderDate: this.viewedOrder.orderDate? this.viewedOrder.orderDate : "", 
        docketNumber: this.viewedOrder.docketNumber? this.viewedOrder.docketNumber : "", 
        orderingInscriptionToFactory: this.viewedOrder.orderingInscriptionToFactory? this.viewedOrder.orderingInscriptionToFactory : "", 
        orderingManufacturer: this.viewedOrder.orderingManufacturer? this.viewedOrder.orderingManufacturer : "", 
        foundation: this.viewedOrder.foundation? this.viewedOrder.foundation : "", 
        totalAmount: this.viewedOrder.totalAmount? this.viewedOrder.totalAmount : "", 
        outstandingAmount: this.viewedOrder.outstandingAmount? this.viewedOrder.outstandingAmount : "", 
        status: this.viewedOrder.status? this.viewedOrder.status : "",
        row: this.viewedOrder.row? this.viewedOrder.row : "",
        grave: this.viewedOrder.grave? this.viewedOrder.grave : "",
        funeralServiceProvider: this.viewedOrder.funeralServiceProvider? this.viewedOrder.funeralServiceProvider : "",
        orderingCrateNumber1: this.viewedOrder.orderingCrateNumber1? this.viewedOrder.orderingCrateNumber1 : "",
        orderingCrateNumber2: this.viewedOrder.orderingCrateNumber2? this.viewedOrder.orderingCrateNumber2 : "",
        orderingCrateNumber3: this.viewedOrder.orderingCrateNumber3? this.viewedOrder.orderingCrateNumber3 : "", 
        description: this.viewedOrder.description? this.viewedOrder.description : "",
      };

      if (this.viewedOrder.invoiceTime != null) {
        viewedSimplifiedOrder.invoiceTime = this.viewedOrder.invoiceTime;
      }

      console.log(this.viewedOrder);
      console.log(viewedSimplifiedOrder);

      firebase.firestore().collection("crm_orders").doc(this.viewedOrder.id)
        .set(this.viewedOrder,
          {merge: true}, (error) => {
            alert('Data could not be saved.' + error)
            this.isUpdating = false;
          })
        .then(() => {
          viewedSimplifiedOrderRef.set(viewedSimplifiedOrder, {merge: true});
          alert("Modify successfully");
          this.isUpdating = false;

          if (!this.dataLists.suburbList.includes(this.viewedOrder.suburb) && this.viewedOrder.suburb != "") {
            this.dataLists.suburbList.push(this.viewedOrder.suburb);
            firebase.firestore().collection("datalists").doc("pMDl8MQ5rNsxrdK020ao")
              .set({suburbList: this.dataLists.suburbList},
                {merge: true});
          }

          if (!this.dataLists.suburbList.includes(this.viewedOrder.section) && this.viewedOrder.section != "") {
            this.dataLists.sectionList.push(this.viewedOrder.section)
            firebase.firestore().collection("datalists").doc("E3QYIcTtYWivCtJBoBSy")
              .set({sectionList: this.dataLists.sectionList},
              {merge: true});
          }

          if (
            (this.viewedOrder.orderDate != null && this.viewedOrder.orderDate.length > 0) ||
            (this.viewedOrder.orderingATA != null && this.viewedOrder.orderingATA.length > 0)
          ) {
            firebase.firestore().collection("follow_up_reports").where('invoice_number', '==', this.viewedOrder.invoiceNumber).get().then((collection) => {
              var reports = collection.docs.map((doc) => doc.data());
              reports.forEach((data) => {
                const report_ref = firebase.firestore().collection("follow_up_reports").doc(data.id);
                report_ref.set({order_placed_date: this.viewedOrder.orderDate, order_received_date: this.viewedOrder.orderingATA }, {merge: true});
              });
            });
          }
        });
    },
    deleteOrder() {
      this.hideModal('modal-delete-confirmation');
      firebase.firestore().collection('crm_orders').doc(this.crmViewedOrderId).delete().then(() => {
        alert('Successfully deleted');
        firebase.firestore().collection('crm_orders_simplified').doc(this.crmViewedOrderId).delete()
        if (this.quote.id != null && this.quote.id.length > 0) {
          firebase.firestore().collection("quotes").doc(this.quote.id)
          .set({orderId: ""},
            {merge: true});
        }
        this.$emit('backTo', 'CRMOrders');
      }).catch((error) => {
        alert("Error removing document: ", error);
      });
    },
    crmAddSmallTask() {
      this.$emit('crmAddSmallTask', this.viewedOrder);
    },
    crmAddInstallation() {
      this.$emit('crmAddInstallation', this.viewedOrder);
    },
    back() {
      this.$emit('backTo', 'CRMOrders');
    },
    crmAddMonumentQuote() {
      this.$emit('CRMAddMonumentQuote', this.viewedOrder);
    },
    crmAddAdditionalInscriptionQuote() {
      this.$emit('CRMAddAdditionalInscriptionQuote', this.viewedOrder);
    },
    downloadFile(index) {
      window.open(this.viewedOrder.files[index].fileURL);
    },
    deleteFile(index) {
      this.deletedFileIndex = index;
      this.showModal("file-deletion-confirmation");
    },
    deleteFileTask() {
      this.isDeleting = true;
      const index = this.deletedFileIndex;
      var deletedFile = this.viewedOrder.files[index];
      this.viewedOrder.files.splice(index, 1);

      var database = firebase.firestore();
      var orderRef = database.collection("crm_orders").doc(this.viewedOrder.id);

      orderRef
        .set(
          {
            files: this.viewedOrder.files,
          },
          { merge: true }
        )
        .then(() => {
          if (deletedFile.fileURL) {
            var storageRef = firebase.storage().ref();
            var desertRef = null;
            if (deletedFile.fileType && deletedFile.fileType.length > 0) {
              desertRef = storageRef.child(
                "crm_orders/" + this.viewedOrder.id + "/" + deletedFile.fileType + "/" + deletedFile.fileName
              );
            } else {
              desertRef = storageRef.child(
                "crm_orders/" + this.viewedOrder.id + "/" + deletedFile.fileName
              );
            }

            // Delete the file
            desertRef
              .delete()
              .then(function() {})
              .catch(function(error) {
                alert(error);
              });
          }
          this.isDeleting = false;

          this.hideModal("file-deletion-confirmation");
        })
        .catch((error) => {
          this.isDeleting = false;
          alert("Error updating document: ", error);
        });
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
      this.selectedFile = null;
    },
    uploadFiles(type) {
      for (var i = 0; i < this.selectedFiles.length; i++) {
        for (var c = 0; c < this.viewedOrder.files.length; c++) {
          if (this.selectedFiles[i].name == this.viewedOrder.files[c].fileName && ( this.viewedOrder.files[c].fileType != null && this.viewedOrder.files[c].fileType == type)) {
            console.log(this.selectedFiles[i].name + this.viewedOrder.files[c].fileName);
            alert("Do not upload duplicate file!");
            return;
          }
        }
      }
      console.log("uploading starts");
      this.selectedFile = null;
      this.progress = 0;
      this.isUploading = true;
      this.isUploadingFile = true;

      if (this.selectedFiles.length > 0) {
        var storageRef = firebase.storage().ref();
        //var self = this;
        // var uploadTasks = [];
        // var index = 0;
        // var subIndex = 0;
        // var urlIndex = 0;
        // var uploadedIndex = 0;
        // var uploadedFiles = this.viewedOrder.files;
        // var uploadingTasks = [];

        for (
          var fileIndex = 0;
          fileIndex < this.selectedFiles.length;
          fileIndex++
        ) {
          var fileName = this.selectedFiles[fileIndex].name;
          this.uploadedFileNames.push(fileName);
        }

        var directoryPrefix = "crm_orders/" + this.viewedOrder.id + "/";
        if (type && type.length > 0) directoryPrefix += type + '/';

        for (
          var uploadedFilesIndex = 0;
          uploadedFilesIndex < this.viewedOrder.files.length;
          uploadedFilesIndex++
        ) {
          this.uploadedFiles.push(this.viewedOrder.files[uploadedFilesIndex]);
        }

        this.uploadFileTask(storageRef, directoryPrefix, 0, type);
      }
    },
    uploadFileTask(storageRef, directoryPrefix, uploadedFilesCount, fileType) {
      if (uploadedFilesCount == this.selectedFiles.length) {
        this.uploadedFiles.concat(this.viewedOrder.files);
        var orderRef = firebase
          .firestore()
          .collection("crm_orders")
          .doc(this.viewedOrder.id);

        orderRef.set(
          {
            files: this.uploadedFiles,
          },
          { merge: true }
        );
        this.viewedOrder.files = this.uploadedFiles;
        this.uploadedFiles = [];
        this.selectedFiles = [];
        this.uploadedFileNames = [];
        this.isUploadingFile = false;

        var email_subject = "";
        var email_recipients = [];
        var attachments = [];
        email_recipients.push(this.viewedOrder.sales.email);
        if (fileType == 'stone_order') {
          email_subject = "#" + this.viewedOrder.invoiceNumber + " - A stone order file has been uploaded"
          email_recipients.push('lizqiu@johnstonemart.com');
          email_recipients.push('rick@johnstonemart.com');
        } else if (fileType == 'purchase_order') {
          email_subject = "#" + this.viewedOrder.invoiceNumber + " - A purchase order file has been uploaded"
          // email_recipients.push('lizqiu@johnstonemart.com');
          email_recipients.push('sales@johnstonemart.com');
          email_recipients.push('rick@johnstonemart.com');
          email_recipients.push('Ivy@johnstonemart.com');
        } else if (fileType == 'complaint') {
          email_subject = "#" + this.viewedOrder.invoiceNumber + " - A complaint file has been uploaded"
          email_recipients.push('lizqiu@johnstonemart.com');
          email_recipients.push('sales@johnstonemart.com');
          email_recipients.push('jacky@johnstonemart.com');
          email_recipients.push('rick@johnstonemart.com');
        } else if (fileType == 'inscription_booking') {
          email_subject = "#" + this.viewedOrder.invoiceNumber + " - An inscription file has been uploaded"
          email_recipients.push('ruichen@johnstonemart.com');
          email_recipients.push('rick@johnstonemart.com');
        } else if (fileType == 'permit') {
          email_subject = "#" + this.viewedOrder.invoiceNumber + " - An permit file has been uploaded"
          email_recipients.push('ruichen@johnstonemart.com');
          email_recipients.push('rick@johnstonemart.com');
        }

        for (var i = 0;i < this.viewedOrder.files.length; i++) {
          if (this.viewedOrder.files[i].fileType == fileType) {
            attachments.push(
              {
                filename: this.viewedOrder.files[i].fileName,
                path: this.viewedOrder.files[i].fileURL,
              }
            );
          }
        }

        if (fileType != 'general') {
          email_recipients.push('rick@johnstonemart.com');

          const notification_email = {
            from: 'info@johnstonemart.com',
            to: email_recipients,
            message: {
              subject: email_subject,
              text: '#' + this.viewedOrder.invoiceNumber +': A ' + fileType + ' file has been uploaded by ' + this.user.name + ' on ' + this.today,
              attachments: attachments,
            }
          }

          console.log(notification_email);
          const mail_ref = firebase.firestore().collection('mail').doc();
          console.log(mail_ref.id);
          mail_ref.set(notification_email);
        }

        return;
      }

      const self = this;
      const uploadingFile = this.selectedFiles[uploadedFilesCount];
      const uploadingTask = storageRef
        .child(directoryPrefix + uploadingFile.name)
        .put(uploadingFile, uploadingFile.type);
      //uploadingTasks.push(uploadingTask);
      uploadingTask.then((data) => {
        data.ref.getDownloadURL().then((url) => {
          self.uploadedFiles.push({
            fileName: this.uploadedFileNames[uploadedFilesCount],
            fileURL: url,
            fileType: fileType,
            uploader: this.user.name,
            uploadDate: this.today,
          });
          ++uploadedFilesCount;
          self.uploadFileTask(
            storageRef,
            directoryPrefix,
            uploadedFilesCount,
            fileType
          );
        });
      });
    },
  },
}
</script>

<style>
.circled-text {
  font-size: 14px;
  border-radius: 10px;
  padding-left: 6px;
  padding-right: 6px;
  color: white;
  background-color: #28a745;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.flex-container > div {
  margin: 0px 10px 0px 10px;
}

.accessory-container {
  border: 1px solid;
  margin-top: 10px;
}

.accessory-container:hover {
  background-color: rgba(150, 150, 150, 0.5);
  
}

.accessory-order-container {
  padding-right: 10%;
  padding-left: 10%;
  font-size: 20px;
}

@media print {
  .print-hiden-content {
    visibility: hidden;
  }

  .bottom-content {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    font-size: 18px;
  }
  
}

</style>